"use client";

import React from "react";
import { Table } from "antd";

import { columns, mobileColumns, tableData } from "./tableDefinition";

import * as styles from "./TiersComparisonTableStyles.module.scss";
import { useWindowSize } from "../../hooks/useWindowSize";

export const TiersComparisonTable = () => {
  const { isMobile } = useWindowSize();

  return (
    <div className={styles.comparisonTable}>
      <div className={styles.tiersContainer}>
        <Table
          sticky
          rowClassName={(_, idx) =>
            idx % 2 === 0 ? styles.rowLight : styles.rowDark
          }
          className={styles.table}
          dataSource={tableData()}
          columns={isMobile ? mobileColumns : columns}
          pagination={false}
          expandable={
            isMobile
              ? {
                  defaultExpandAllRows: true,
                  showExpandColumn: false,
                  expandedRowClassName: () => "bg-transparent",
                  expandedRowRender: (record) => {
                    return <div>{record.features}</div>;
                  },
                }
              : undefined
          }
        />
      </div>
    </div>
  );
};
